import React from 'react';
import { Stack, Typography, Divider, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { TabsOption } from 'global';
import { TabsContainer } from 'components/shared/TabsContainer/TabsContainer';
import { CardBackground } from 'components/CardBackground/CardBackground';

interface Props<T extends string> {
  tabs: TabsOption<T>[];
  forceExpanded?: boolean;
}

export const EquipmentDetailsTabbedContent = <T extends string>({ tabs, forceExpanded }: Props<T>) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const shouldExpand = forceExpanded || isMobile;

  if (shouldExpand) {
    return (
      <Stack gap={3} mt={2}>
        {tabs
          .filter(tab => tab.isVisible)
          .map(tab => (
            <Stack key={tab.value} gap={1}>
              <Typography variant="subtitle1" fontWeight={600}>
                {tab.label}
              </Typography>
              <Divider />
              {tab.component}
            </Stack>
          ))}
      </Stack>
    );
  }

  return <TabsContainer<T> tabs={tabs} isSyncWithAnchor TabsLabelWrapper={CardBackground} />;
};
